export default {
    "en": {
        "customers": {
            "add": "Add customer",
            "edit": "Edit customer",
            "delete": "Delete customer",
            "not_find": "Can not find a client with this code.",
            "id": "Id",
            "contact": "Contact",
            "contact_placeholder": "Enter the customer's contact",
            "address": "Address",
            "address_placeholder": "Enter the customer's address",
            "state": "State",
            "state_placeholder": "Enter the state",
            "phone": "Phone",
            "phone_placeholder": "Enter the customer's phone",
            "email": "Email",
            "email_placeholder": "Enter the customer's email",
            "created_at": "Created at",
            "report_title": "Customers Report"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "front": {
            "added_successfully": "It has been added successfully.",
            "updated_successfully": "It has been updated successfully.",
            "deleted_successfully": "It has been deleted successfully.",
            "imported_successfully": "It has been imported successfully.",
            "delete_modal": "Delete",
            "delete_confirmation": "Are you sure you want to delete the {model} {attribute}?",
            "delete_confirmation2": "Are you sure you want to delete {model} {attribute}?",
            "action_confirmation": "Are you sure you want to {action} this {model}?",
            "action_confirmation2": "Are you sure you want to {action} this {model}?",
            "import_modal": "Import {model} from CSV or Excel file"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "errors": {
            "fatal_error": "A fatal error occurred, please contact us.",
            "generic_error": "An error occurred, please try again.",
            "unauthorized": "Unauthorized.",
            "forbidden": "Forbidden.",
            "connection_error": "Connection error",
            "action_unauthorized": "This action is unauthorized."
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Overview",
            "user": "User",
            "users": "Users",
            "customer": "Customer",
            "customers": "Customers",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "purchase_order": "Purchase Order",
            "purchase_orders": "Purchase Orders",
            "description": "An Overview of your {attribute}",
            "search": "Search",
            "filters": "Filters",
            "clear": "Clear",
            "apply": "Apply",
            "select_date": "Select a date",
            "multiple": "Multiple",
            "display_list": "Display list",
            "display_grid": "Display grid (enabled)",
            "print": "Print",
            "delete": "Delete",
            "add": "Add",
            "addDetail": "Add Detail",
            "edit": "Edit",
            "save": "Save",
            "accept": "Accept",
            "cancel": "Cancel",
            "view": "View",
            "import": "Import",
            "registered_on": "Registered on",
            "order_by": "Order by",
            "options": "More options",
            "notifications": "Notifications",
            "messages": "Messages",
            "no_notifications": "No notifications",
            "no_messages": "No messages",
            "see_all": "See all",
            "exit": "Exit",
            "cancelled": "Cancelled",
            "sold": "Sold",
            "invoiced": "Invoiced",
            "paid": "Paid",
            "pending": "Pending",
            "approved": "Approved",
            "received": "Received",
            "send": "Sent",
            "action_sold": "Sell",
            "action_invoiced": "Invoice",
            "action_paid": "Pay",
            "action_approved": "Approved",
            "action_received": "Received",
            "action_send": "Send",
            "action_active": "Active",
            "action_inactive": "Inactive"
        },
        "users": {
            "add": "Add user",
            "edit": "Edit user",
            "delete": "Delete user",
            "not_find": "Can not find user with this code.",
            "actived_error": "User is already active",
            "inactived_error": "User is already inactive",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the user's name",
            "email": "Email",
            "email_placeholder": "Enter the user's email",
            "password": "Password",
            "password_placeholder": "Enter the user's password",
            "confirm_password": "Confirm Password",
            "confirm_password_placeholder": "Enter the user's confirm password",
            "role": "Role",
            "role_placeholder": "Enter the user's role",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Users Report"
        },
        "articles": {
            "add": "Add address",
            "edit": "Edit address",
            "delete": "Delete address",
            "not_find": "Can not find a address with this code.",
            "id": "Id",
            "created_at": "Created at",
            "report_title": "Address Report"
        },
        "login": {
            "email": "Email",
            "password": "Password",
            "keep_connected": "Keep connected",
            "forgot_password": "Forgot password",
            "login": "Login",
            "reset_password": "Reset password",
            "send_reset_link": "Send the reset link",
            "password_confirmation": "Password confirmation",
            "welcome": "Welcome",
            "description": "Description app"
        },
        "purchase_orders": {
            "add": "Add purchase order",
            "edit": "Edit purchase order",
            "delete": "Delete purchase order",
            "not_find": "Can not find a purchase order with this code.",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Enter the purchase order's folio",
            "created_at": "Created at",
            "report_title": "Purchase Orders Report"
        }
    },
    "es": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "passwords": {
            "password": "Las contraseñas deben tener al menos seis caracteres y coincidir con la confirmación.",
            "reset": "¡Tu contraseña ha sido restablecida!",
            "sent": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "token": "Este token de restablecimiento de contraseña no es válido.",
            "user": "No podemos encontrar un usuario con esa dirección de correo electrónico."
        },
        "front": {
            "added_successfully": "Ha sido agregado con éxito.",
            "sent_successfully": "Ha sido enviado con éxito.",
            "updated_successfully": "Ha sido actualizado con éxito.",
            "deleted_successfully": "Ha sido eliminado con éxito.",
            "imported_successfully": "Ha sido importado con éxito.",
            "delete_modal": "Eliminar",
            "delete_confirmation": "¿Seguro que quieres eliminar la {model} {attribute}?",
            "delete_confirmation2": "¿Seguro que quieres eliminar el {model} {attribute}?",
            "action_confirmation": "¿Seguro que deseas {action} esta {model}?",
            "action_confirmation2": "¿Seguro que deseas {action} este {model}?",
            "import_modal": "Importar {model} desde un archivo CSV o Excel"
        },
        "validation": {
            "accepted": "El {attribute} debe ser aceptado.",
            "active_url": "El {attribute} no es una URL válida.",
            "after": "El {attribute} debe ser una fecha después a {date}.",
            "after_or_equal": "El {attribute} debe ser una fecha posterior o igual a {date}.",
            "alpha": "El {attribute} solo puede contener letras.",
            "alpha_dash": "El {attribute} solo puede contener letras, números, guiones y guiones bajos.",
            "alpha_num": "El {attribute} solo puede contener letras y números.",
            "array": "El {attribute} debe ser una matriz.",
            "before": "El {attribute} debe ser una fecha antes de {date}.",
            "before_or_equal": "El {attribute} debe ser una fecha antes o igual a {date}.",
            "between": {
                "numeric": "El {attribute} debe estar entre {min} y {max}.",
                "file": "El {attribute} debe estar entre {min} y {max} kilobytes.",
                "string": "El {attribute} debe estar entre {min} y {max} caracteres.",
                "array": "El {attribute} debe estar entre {min} y {max} artículos."
            },
            "boolean": "El {attribute} el campo debe ser verdadero o falso.",
            "confirmed": "El {attribute} la confirmación no coincide.",
            "date": "La {attribute} no es una fecha valida.",
            "date_format": "La {attribute} no coincide con el formato {format}.",
            "different": "El {attribute} y {other} deben ser diferentes.",
            "digits": "El {attribute} deben ser {digits} dígitos.",
            "digits_between": "El {attribute} debe estar entre {min} y {max} dígitos.",
            "dimensions": "El {attribute} tiene dimensiones de imagen inválidas.",
            "distinct": "El {attribute} campo tiene un valor duplicado.",
            "email": "El {attribute} debe ser una dirección de correo electrónico válida.",
            "exists": "El seleccionado {attribute} no es válido.",
            "file": "El {attribute} debe ser un archivo.",
            "filled": "El {attribute} campo debe tener un valor.",
            "gt": {
                "numeric": "El {attribute} debe ser mayor que {value}.",
                "file": "El {attribute} debe ser mayor que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor que {value} caracteres.",
                "array": "El {attribute} debe tener más que {value} artículos."
            },
            "gte": {
                "numeric": "El {attribute} debe ser mayor o igual que {value}.",
                "file": "El {attribute} debe ser mayor o igual que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor o igual que {value} caracteres.",
                "array": "El {attribute} debe tener {value} artículos o más."
            },
            "image": "La {attribute} debe ser una imagen.",
            "in": "El seleccionado {attribute} no es válido.",
            "in_array": "El {attribute} campo no existe en {other}.",
            "integer": "El {attribute} debe ser un entero.",
            "ip": "La {attribute} debe ser una dirección IP válida.",
            "ipv4": "La {attribute} debe ser una dirección IPv4 válida.",
            "ipv6": "La {attribute} debe ser una dirección IPv6 válida.",
            "json": "La {attribute} debe ser una cadena JSON válida.",
            "lt": {
                "numeric": "El {attribute} debe ser menor que {value}.",
                "file": "El {attribute} debe ser menor que {value} kilobytes.",
                "string": "El {attribute} debe ser menor que {value} caracteres.",
                "array": "El {attribute} debe tener menos que {value} artículos."
            },
            "lte": {
                "numeric": "El {attribute} debe ser menor o igual {value}.",
                "file": "El {attribute} debe ser menor o igual {value} kilobytes.",
                "string": "El {attribute} debe ser menor o igual {value} caracteres.",
                "array": "El {attribute} no debe tener más de {value} artículos."
            },
            "max": {
                "numeric": "El {attribute} no puede ser mayor que {max}.",
                "file": "El {attribute} no puede ser mayor que {max} kilobytes.",
                "string": "El {attribute} no puede ser mayor que {max} caracteres.",
                "array": "El {attribute} no puede tener más de {max} artículos."
            },
            "mimes": "El {attribute} must be a file of type: {values}.",
            "mimetypes": "Los {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "El {attribute} al menos debe ser {min}.",
                "file": "El {attribute} al menos debe ser {min} kilobytes.",
                "string": "El {attribute} al menos debe ser {min} caracteres.",
                "array": "El {attribute} debe tener al menos {min} artículos."
            },
            "not_in": "El seleccionado {attribute} no es válido.",
            "not_regex": "El {attribute} formato no es válido.",
            "numeric": "El {attribute} tiene que ser un número.",
            "present": "El {attribute} campo debe estar presente.",
            "regex": "El {attribute} formato no es válido.",
            "required": "El {attribute} se requiere campo.",
            "required_if": "El {attribute} campo es requerido cuando {other} es {value}.",
            "required_unless": "El {attribute} campo es obligatorio a menos que {other} es en {values}.",
            "required_with": "El {attribute} campo es requerido cuando {values} esta presente.",
            "required_with_all": "El {attribute} campo es requerido cuando {values} esta presente.",
            "required_without": "El {attribute} campo es requerido cuando {values} no esta presente.",
            "required_without_all": "El {attribute} campo es requerido cuando ninguno de {values} estan presentes.",
            "same": "El {attribute} y {other} debe coincidir con.",
            "size": {
                "numeric": "El {attribute} debe ser {size}.",
                "file": "El {attribute} debe ser {size} kilobytes.",
                "string": "El {attribute} debe ser {size} caracteres.",
                "array": "El {attribute} debe contener {size} artículos."
            },
            "string": "El {attribute} debe ser una cuerda.",
            "timezone": "El {attribute} debe ser una zona válida.",
            "unique": "El {attribute} ya se ha tomado.",
            "uploaded": "El {attribute} no se pudo cargar.",
            "url": "El {attribute} formato no válido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "contact": {
            "add": "Agregar dirección",
            "edit": "Editar dirección",
            "delete": "Eliminar Dirección",
            "not_find": "No se puede encontrar un dirección con este código.",
            "id": "Id",
            "product": "Producto",
            "quantity": "Cantidad",
            "full_name": "Nombre completo",
            "phone": "Telefono",
            "email": "Correo electronico",
            "created_at": "Creado en",
            "report_title": "Reporte de Direcciones"
        },
        "errors": {
            "fatal_error": "Se produjo un error fatal, póngase en contacto con nosotros.",
            "generic_error": "Ha ocurrido un error. Por favor intente de nuevo.",
            "unauthorized": "No autorizado.",
            "connection_error": "Error de conexión",
            "action_unauthorized": "No estas autorizado para realizar esta acción"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "purchase_requisition_detail": {
            "add": "Agregar orden de requisición",
            "edit": "Editar orden de requisición",
            "delete": "Eliminar requisición",
            "not_find": "No se puede encontrar un orden de requisición con este código.",
            "id": "Id",
            "product": "Producto",
            "quantity": "Cantidad",
            "unit_price": "Precio unitario",
            "unit_measurement": "Unidad de medida",
            "discount_price": "Precio Descuento",
            "total": "Total",
            "subtotal": "Subtotal",
            "shipping_cost": "Costo Envio",
            "total_w_shipping": "Total",
            "created_at": "Creado en",
            "report_title": "Reporte de requisiciónes"
        },
        "strings": {
            "dashboard": "Inicio",
            "overview": "Inicio",
            "users": "Usuarios",
            "user": "Usuario",
            "inventories": "Inventario",
            "purchase_requisitions": "Ordenes de requisición",
            "purchase_requisition": "Orden de requisición",
            "pos": "Nueva orden",
            "description": "Un resumen de sus {attribute}",
            "search": "Buscar",
            "filters": "Filtros",
            "clear": "Limpiar",
            "apply": "Aplicar",
            "select_date": "Selecciona una fecha",
            "multiple": "Selección multiple",
            "display_list": "Ver en lista",
            "display_grid": "Ver en grid (deshabilitado)",
            "print": "Imprimir",
            "delete": "Eliminar",
            "add": "Agregar",
            "addDetail": "Agregar Detalle",
            "edit": "Editar",
            "save": "Guardar",
            "accept": "Aceptar",
            "cancel": "Cancelar",
            "view": "Ver",
            "import": "Importar",
            "registered_on": "Registrado desde",
            "order_by": "Ordenado por",
            "options": "Más opciones",
            "notifications": "Notificaciones",
            "messages": "Mensajes",
            "no_notifications": "No tienes notificaciones",
            "no_messages": "No tienes mensajes",
            "see_all": "Ver",
            "exit": "Salir",
            "created_at": "Creado en:",
            "cancelled": "Cancelado",
            "sold": "Vendido",
            "invoiced": "Facturado",
            "paid": "Pagado",
            "pending": "Pendiente",
            "approved": "Aprobado",
            "received": "Recibido",
            "send": "Enviado",
            "action_sold": "Pagar",
            "action_invoiced": "Facturar",
            "action_paid": "Pagar",
            "action_approved": "Aprobar",
            "action_received": "Recibir",
            "action_send": "Enviar",
            "action_active": "Activar",
            "action_inactive": "Inactivar"
        },
        "users": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "role": "Role",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "address": "Dirrección",
            "address_placeholder": "Ingrese la dirección",
            "contact": "Contacto",
            "contact_placeholder": "Ingrese el contacto",
            "phone": "Teléfono",
            "phone_placeholder": "Ingrese el teléfono",
            "tradename": "Nombre comercial",
            "tradename_placeholder": "Ingrese el nombre comercial",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios"
        },
        "articles": {
            "add": "Agregar dirección",
            "edit": "Editar dirección",
            "delete": "Eliminar Dirección",
            "not_find": "No se puede encontrar un dirección con este código.",
            "id": "Id",
            "created_at": "Creado en",
            "report_title": "Reporte de Direcciones"
        },
        "login": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "welcome": "Bienvenido",
            "description": "Descripción"
        },
        "inventories": {
            "add": "Agregar inventario",
            "edit": "Editar inventario",
            "delete": "Eliminar inventario",
            "not_find": "No se puede encontrar un dirección con este código.",
            "id": "Id",
            "sku": "Sku",
            "sku_placeholder": "Ingrese el sku",
            "product": "Producto",
            "product_placeholder": "Ingrese el producto",
            "quantity": "Cantidad",
            "quantity_placeholder": "Ingrese la cantidad",
            "unit_price": "Precio unitario",
            "unit_price_placeholder": "Ingrese el precio unitario",
            "unit_measurement": "Unidad de medida",
            "unit_measurement_placeholder": "Ingrese la unidad de medida",
            "created_at": "Creado en",
            "report_title": "Reporte de inventario"
        },
        "purchase_requisitions": {
            "add": "Agregar orden de requisición",
            "edit": "Editar orden de requisición",
            "delete": "Eliminar requisición",
            "not_find": "No se puede encontrar un orden de requisición con este código.",
            "id": "Id",
            "amount": "Monto",
            "user_name": "Usuario",
            "created_at": "Creado en",
            "user_id": "Usuario",
            "name": "Usuario",
            "subtotal": "Subtotal",
            "shipping_cost": "Costo Envio",
            "total_w_shipping": "Total",
            "report_title": "Reporte de requisiciónes"
        }
    }
}
